<template>
	<div class="full box">
		<template v-if="device!='pc'">
			<div>
				<van-cell v-for="(item,index) in activities" :key="index" :title="item.content"
					:label="$systemMethods.timestampToDate(item.create_time)" @click="open(item)">
					<template #title>
						<div v-if="item.dataid" style="color: #409EFF;">{{item.content}}</div>
						<div v-else>{{item.content}}</div>
					</template>
				</van-cell>
			</div>
		</template>
		<template v-else>
			<el-timeline :reverse="reverse" size="mini">
				<el-timeline-item v-for="(activity, index) in activities" :key="index"
					:timestamp="$systemMethods.timestampToDate(activity.create_time)">
					<el-link v-if="activity.dataid" type="primary"
						@click="open(activity)">{{activity.content}}</el-link>
					<span v-else>{{activity.content}}</span>
				</el-timeline-item>
			</el-timeline>
			<component ref="customcomponent" :key="componentKey" :is="formModule.component" :name="formModule.name"
				:param="formModule.param" @modalhide="customcomponentHide" />
		</template>
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 10px 10px;
		overflow: auto;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	export default {
		name: 'messageIndex',
		props: {
			type: {
				type: Number,
				default: () => {
					return 1
				}
			},
		},
		data() {
			return {
				reverse: false,
				activities: [],
				device: window.systemMethods.device(),
				componentKey: Math.random(),
				formModule: {
					component: null,
					name: name,
					id: null,
					param: null
				}
				// activities: [{
				// 	content: '创建成功',
				// 	timestamp: '2018-04-15'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-13'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }, {
				// 	content: '创建成功',
				// 	timestamp: '2018-04-11'
				// }]
			}
		},
		watch: {
			socketTimestamp() {
				let message = this.$store.state.system.websocketMessage
				if (message.event == 'NOTICE') {
					this.list()
				}
			}
		},
		created() {
			this.list()
		},
		mounted() {
			
		},
		computed: {
			socketTimestamp() {
				return this.$store.state.system.socketTimestamp
			},
			customformMap() {
				return this.$store.state.customformMap
			}
		},

		methods: {
			open(activity) {
				if (activity.dataid) {
					if (activity.type == 'system') {
						let moduleName = activity.formname.replace('c_', '')
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: moduleName,
								id: activity.dataid,
								controlltype: 3,
								windowName: '预览',
								extra: activity.extra ? JSON.stringify(activity.extra) :
									'{"componentname":"form"}',
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, moduleName + 'preview',
								this.$store.state.system.windowConfig)
							win.onload = () => {

							}
						}
					} else {
						import(`@/${this.customformMap[activity.formname]}`).then((res) => {
							activity.param.readonly = true
							this.formModule = {
								component: res.default,
								name: activity.formname,
								id: activity.dataid,
								param: activity.param
							}
							this.$nextTick(()=>{
								this.$refs.customcomponent.modalShow()		
							})					
						})
					}

				}
			},
			customcomponentHide() {
				this.formModule = {
					component: null,
					name: null,
					id: null,
					param: null
				}
			},
			list() {
				return new Promise((resove) => {
					let data = {}
					if (this.type == 1) {
						data.staffid = this.$store.state.system.user.id
					}
					this.$api.message.list(data).then((res) => {
						this.activities = res
						resove()
					})
				})
			},
			handleChange() {

			}
		},
		components: {

		}
	}
</script>